import React from 'react';
import { Wrench, Mail, Phone } from 'lucide-react';

const MaintenanceMode = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* Icon */}
        <div className="mb-8 flex justify-center">
          <div className="bg-white bg-opacity-10 p-6 rounded-full">
            <Wrench className="w-16 h-16 text-yellow-400 animate-pulse" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Website Under Maintenance
        </h1>

        {/* Description */}
        <p className="text-xl text-blue-100 mb-8">
          We're currently performing scheduled maintenance to improve your experience.
          We'll be back online shortly.
        </p>

        {/* Info Box */}
        <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-lg p-6 mb-8">
          <p className="text-blue-100 mb-4">
            Our team is working hard to bring you an enhanced experience.
            Thank you for your patience.
          </p>
          
          {/* Contact Info */}
          <div className="space-y-3 text-blue-200">
            <div className="flex items-center justify-center gap-2">
              <Mail className="w-5 h-5" />
              <span>office@towertech-xm.com</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <Phone className="w-5 h-5" />
              <span>+86 15381939338</span>
            </div>
          </div>
        </div>

        {/* Company Logo/Name */}
        <div className="text-blue-300">
          <p className="text-lg font-semibold">Xiamen Tower Technology Co., Ltd.</p>
          <p className="text-sm">Your Trusted Partner for Import from China</p>
        </div>

        {/* Admin Access Note */}
        <div className="mt-8 text-blue-400 text-sm">
          <p>Administrator? <a href="/admin" className="text-yellow-400 hover:text-yellow-300 underline">Login here</a></p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceMode;
